<div class="content-front">
      <div *ngIf="category?.page?.totalPages>1" class="paggination-wrapper">
            <ul>
                  <li class="page-item">
                        <a class="page-link" *ngIf="!category?.page?.first"
                              (click)='changePage(category?.pageRequest,category?.searchParam,category?.page?.number-1, "page")'>
                              <!-- Prethodna -->
                              <img class="icon-pagination" src="assets/icons/dark-green/arrow-ionicons-left.svg" alt="Arrow left">
                        </a>
                  </li>
                  <ng-template ngFor let-page [ngForOf]="createRange(category?.page?.totalPages)" let-i="index+1">
                        <li class="page-item" [ngClass]="{active:page-1 === category?.page?.number}">
                              <a class="page-link"
                                    *ngIf="category?.page?.number <= page+1 && category?.page?.number >= page-3"
                                    (click)='changePage(category?.pageRequest,category?.searchParam,page-1, "page")'>
                                    {{page}}
                              </a>
                        </li>
                  </ng-template>
                  <li class="page-item">
                        <a class="page-link" *ngIf="!category?.page?.last"
                              (click)='changePage(category?.pageRequest,category?.searchParam,category?.page?.number+1, "page")'>
                              <!-- Sledeća -->
                              <img class="icon-pagination" src="assets/icons/dark-green/arrow-ionicons-right.svg" alt="Arrow right">
                        </a>
                  </li>
            </ul>
      </div>
</div>